module.exports = __webpack_public_path__ + "static/img/main1.b0854533.png";